
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-3 md:space-y-0">
          {/* Company Info */}
          <div className="flex items-center space-x-2 sm:space-x-3">
            <div className="w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center flex-shrink-0">
              <img 
                src="https://static.readdy.ai/image/5743fa161097a13fb02471cc7f354468/7c15234fd7b4bba753ec95055981df06.png" 
                alt="株式会社ソーシャルパス ロゴ" 
                className="w-6 h-6 sm:w-8 sm:h-8 object-contain"
              />
            </div>
            <span className="text-base sm:text-xl font-bold">株式会社ソーシャルパス</span>
          </div>

          {/* Copyright */}
          <p className="text-gray-400 text-xs sm:text-sm text-center">
            © 2025 Social Path Co.,Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
